import type { ItemSalesPlan, TaskHourRange } from "../types/types";

/**
 * A card writes to /daily-tasks as one row keyed on toHour, and the server mirrors
 * that write onto the single itemSalesPlan row whose plannedDayHour equals toHour.
 * toHour is therefore the last hour the card covers - inclusive - and anchorDto is
 * the row the card reads its own produced/available/status/comment back from.
 */
export function buildTaskRange(
  dtos: ItemSalesPlan[],
): (TaskHourRange & { anchorDto: ItemSalesPlan }) | null {
  if (dtos.length === 0) return null;

  const sorted = [...dtos].sort((a, b) =>
    a.plannedDayHour.localeCompare(b.plannedDayHour),
  );
  const anchorDto = sorted[sorted.length - 1];

  return {
    fromHour: sorted[0].plannedDayHour,
    toHour: anchorDto.plannedDayHour,
    anchorDto,
  };
}
